<template>
  <nav class="navbar fixed-top navbar-expand-lg navbar-dark bg-dark">
    <div class="toolbar">
      <div class="title">{{ title }}</div>
      <div v-if="logged_in" class="actions">
        <button @click="openServices" class="logout-button">Services</button>
        <button @click="openAccount" class="logout-button">Manage Account</button>
        <button @click="logout" class="logout-button">Logout</button>
      </div>
    </div>
  </nav>
</template>

<script>
import Cookies from 'js-cookie'
import DisableDevtool from 'disable-devtool';

// Internal helper functions, moved from Halo component
function ParseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    const payload = JSON.parse(jsonPayload);
    return payload
}

function GetSession(home = "") {
  const cookie = Cookies.get("API_TOKEN")
  let jwt = { services: [] } 
  if(home?.length){
    jwt.home_path = home
  }
  if(cookie)
     jwt = ParseJwt(cookie)
  return jwt
}

export default {
  name: 'Navbar-main',
  data() {
    const jwt = GetSession(this.home_url)
    return {
      home_url: `https://${process.env.VUE_APP_DOMAIN}`,
      env: process.env.NODE_ENV,
      home: jwt.home_path,
      title: document.getElementsByTagName("title")[0].innerHTML,
      services: jwt.services,
      logged_in: jwt.name,
    }
  },
  methods: {
    extractTLD(url) {
      if (!url?.length)
        return ""
      const hostname = new URL(url).hostname;
      return hostname.split('.').slice(-2).join('.');
    },
    openServices() {
      window.location = this.home
    },
    logout(addRedirect = false) {
      const settings = this.env == 'development' ? {} : {
        secure: true, 
        domain: this.extractTLD(this.home_url),
        sameSite: "Strict",
      };
      if (!addRedirect && !confirm("Are you sure")) {
        return;
      }
      Cookies.remove("API_TOKEN", settings)
      Cookies.remove("REFRESH_TOKEN", settings)
      let url = `/login`
      if (addRedirect) {
        url += `?redirect=${window.location.href}`
      }
      window.location = url
    },
    openAccount() {
      window.open(`${this.home}/account`, '_blank');
    },
    refreshToken() {
    }
  },
  created() {
    const settings = this.env == 'development' ? {} : {
      domain: this.extractTLD(this.home_url)
    };
    const params = new URLSearchParams(document.location.search);
    const s = params.get("logout");
    if (s) {
      Cookies.remove("API_TOKEN", settings)
      const idpLogout = window.localStorage["logout_link"]
      if (idpLogout) {
        window.location = idpLogout
        return
      }
      Cookies.remove("REFRESH_TOKEN", settings)
      if (s?.includes("http")) {
        window.location = s
        return
      }
      window.location = "/login"
    }

    // Halo bar logic
    if (this.env?.length && this.env != 'development') {
      DisableDevtool({
        ondevtoolopen: () => {
          const settings = {
            secure: true,
            domain: this.extractTLD(this.home_url),
            sameSite: "Strict",
          };
          Cookies.remove("simuam", settings);
          Cookies.remove("API_TOKEN", settings);
          Cookies.remove("REFRESH_TOKEN", settings);
          window.location = `/login`;
        },
      });
    }

    const jwt = GetSession(this.home_url);
    if (!jwt.exp) {
      return;
    }
    
    const expTime = jwt.exp * 1000;
    setInterval(() => {
      const now = (new Date()).getTime();
      if (now > expTime) {
        this.logout(true);
      }
    }, 30 * 1000);
  }
}
</script>

<style scoped>
.btn {
  margin-left: 10px;
}
span.text-white {
  margin-right: 10px;
}
#navbarText ul {
  flex: 1;
}
.router-link-active {
  color: #fff;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  background-color: #333;
  color: #fff;
  padding: 0 10px;
  position: fixed;
  width: 100%;
  top: 0px;
  z-index: 40;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.title {
  font-size: 14px;
  margin-left: 10px;
}
.actions {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 14px;
}
.logout-button {
  background-color: transparent;
  color: #fff;
  border: none;
  cursor: pointer;
}
</style>